import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../Environment/environment';
@Component({
  selector: 'app-hpmounting-pos',
  templateUrl: './hpmounting-pos.component.html',
  styleUrl: './hpmounting-pos.component.css'
})
export class HPMountingPosComponent {
  constructor(public dialogRef: MatDialogRef<HPMountingPosComponent>,public dialog: MatDialog) {
    this.AssetbasePath = environment.assetsPath;
  }
  AssetbasePath:any;
  selectImage(imageName: string) {
    this.dialogRef.close(imageName); // Close the dialog and pass the selected image name
  }
  closePopup(){
    this.dialog.closeAll()
    }
}
